module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"go":"Go"},"es":{"go":"Ir"},"sw":{"go":"Nenda"}}')
  delete Component.options._Ctor
}
